import { createContext } from 'react';
const ViewConfigContext = /*#__PURE__*/createContext({});
export default ViewConfigContext;